import { createElementVNode as _createElementVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6af325f5"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "buy-page-container" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "input-header buy-0" }, "Select The Product", -1))
const _hoisted_3 = { class: "input-group" }
const _hoisted_4 = { class: "radio-choice-pair" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "radio-label",
  for: "contactChoice1"
}, [
  /*#__PURE__*/_createElementVNode("span", { class: "buy-1" }, "Unlimited 1 Month"),
  /*#__PURE__*/_createElementVNode("span", { class: "price-span product-price-0" }, "290₾")
], -1))
const _hoisted_6 = { class: "radio-choice-pair" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "radio-label",
  for: "contactChoice2"
}, [
  /*#__PURE__*/_createElementVNode("span", { class: "buy-2" }, "Unlimited 3 Months"),
  /*#__PURE__*/_createElementVNode("span", { class: "price-span product-price-1" }, "780₾")
], -1))
const _hoisted_8 = { class: "radio-choice-pair" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "radio-label",
  for: "contactChoice3"
}, [
  /*#__PURE__*/_createElementVNode("span", { class: "buy-3" }, "Unlimited 6 Months"),
  /*#__PURE__*/_createElementVNode("span", { class: "price-span product-price-2" }, "1280₾")
], -1))
const _hoisted_10 = { class: "radio-choice-pair" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "radio-label",
  for: "contactChoice4"
}, [
  /*#__PURE__*/_createElementVNode("span", { class: "buy-4" }, "Unlimited 1 Year"),
  /*#__PURE__*/_createElementVNode("span", { class: "price-span product-price-3" }, "2360₾")
], -1))
const _hoisted_12 = { class: "radio-choice-pair invisible" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "radio-label",
  for: "contactChoice5"
}, [
  /*#__PURE__*/_createElementVNode("span", { class: "buy-10" }, "Personal Trainer (1 Visit)"),
  /*#__PURE__*/_createElementVNode("span", { class: "price-span product-price-4" }, "50₾")
], -1))
const _hoisted_14 = { class: "radio-choice-pair invisible" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "radio-label",
  for: "contactChoice6"
}, [
  /*#__PURE__*/_createElementVNode("span", { class: "buy-11" }, "Personal Trainer (12 Visits)"),
  /*#__PURE__*/_createElementVNode("span", { class: "price-span product-price-5" }, "550₾")
], -1))
const _hoisted_16 = { class: "radio-choice-pair" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "radio-label",
  for: "contactChoice7"
}, [
  /*#__PURE__*/_createElementVNode("span", { class: "buy-12" }, "VIP"),
  /*#__PURE__*/_createElementVNode("span", { class: "price-span product-price-6" }, "150₾")
], -1))
const _hoisted_18 = { class: "radio-choice-pair" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "radio-label",
  for: "contactChoice8"
}, [
  /*#__PURE__*/_createElementVNode("span", { class: "buy-13" }, "Boxing (12 Visits)"),
  /*#__PURE__*/_createElementVNode("span", { class: "price-span product-price-7" }, "270₾")
], -1))
const _hoisted_20 = /*#__PURE__*/_createStaticVNode("<div class=\"input-group-2\" data-v-6af325f5><label class=\"input-label-class buy-5\" for=\"first-name\" data-v-6af325f5>First Name:</label><input type=\"text\" id=\"first-name\" name=\"first-name\" required data-v-6af325f5></div><div class=\"input-group-2\" data-v-6af325f5><label class=\"input-label-class buy-6\" for=\"last-name\" data-v-6af325f5>Last Name:</label><input type=\"text\" id=\"last-name\" name=\"last-name\" required data-v-6af325f5></div><div class=\"input-group-2\" data-v-6af325f5><label class=\"input-label-class buy-7\" for=\"id-number\" data-v-6af325f5>ID Number:</label><input type=\"text\" id=\"id-number\" name=\"id-number\" required data-v-6af325f5></div><div class=\"input-group-2\" data-v-6af325f5><label class=\"input-label-class buy-8\" for=\"e-mail\" data-v-6af325f5>E-mail:</label><input type=\"text\" id=\"e-mail\" name=\"e-mail\" required data-v-6af325f5></div>", 4)
const _hoisted_24 = { class: "submit-button-container" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("input", {
          onChange: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.radioCheck && _ctx.radioCheck(...args))),
          type: "radio",
          id: "contactChoice1",
          name: "product",
          value: "1",
          required: ""
        }, null, 32),
        _hoisted_5
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("input", {
          onChange: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.radioCheck && _ctx.radioCheck(...args))),
          type: "radio",
          id: "contactChoice2",
          name: "product",
          value: "2"
        }, null, 32),
        _hoisted_7
      ]),
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("input", {
          onChange: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.radioCheck && _ctx.radioCheck(...args))),
          type: "radio",
          id: "contactChoice3",
          name: "product",
          value: "3"
        }, null, 32),
        _hoisted_9
      ]),
      _createElementVNode("div", _hoisted_10, [
        _createElementVNode("input", {
          onChange: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.radioCheck && _ctx.radioCheck(...args))),
          type: "radio",
          id: "contactChoice4",
          name: "product",
          value: "4"
        }, null, 32),
        _hoisted_11
      ]),
      _createElementVNode("div", _hoisted_12, [
        _createElementVNode("input", {
          onChange: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.radioCheck && _ctx.radioCheck(...args))),
          type: "radio",
          id: "contactChoice5",
          name: "product",
          value: "5"
        }, null, 32),
        _hoisted_13
      ]),
      _createElementVNode("div", _hoisted_14, [
        _createElementVNode("input", {
          onChange: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.radioCheck && _ctx.radioCheck(...args))),
          type: "radio",
          id: "contactChoice6",
          name: "product",
          value: "6"
        }, null, 32),
        _hoisted_15
      ]),
      _createElementVNode("div", _hoisted_16, [
        _createElementVNode("input", {
          onChange: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.radioCheck && _ctx.radioCheck(...args))),
          type: "radio",
          id: "contactChoice7",
          name: "product",
          value: "7"
        }, null, 32),
        _hoisted_17
      ]),
      _createElementVNode("div", _hoisted_18, [
        _createElementVNode("input", {
          onChange: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.radioCheck && _ctx.radioCheck(...args))),
          type: "radio",
          id: "contactChoice8",
          name: "product",
          value: "8"
        }, null, 32),
        _hoisted_19
      ])
    ]),
    _hoisted_20,
    _createElementVNode("div", _hoisted_24, [
      _createElementVNode("button", {
        onClick: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.onSubmitPress && _ctx.onSubmitPress(...args))),
        class: "submit-button buy-9",
        id: "submitButton"
      }, " Submit ")
    ])
  ]))
}